var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M468.808 256.123v-145.08c-13.988-60.6-65.844-23.89-65.844-23.89L39.936 385.475c-79.872 53.022-5.243 92.64-5.243 92.64L391.864 773.52c71.68 50.105 76.913-26.224 76.913-26.224V612.71c362.414-108.37 510.976 324.537 510.976 324.537 13.988 23.89 22.139 0 22.139 0 139.295-649.667-533.084-681.124-533.084-681.124z"
  })));
};
export default SvgBack;